import type { FC } from 'react';
import React from 'react';
import { Box } from '@mui/material';

interface CustomTabPanelProps {
  children: React.ReactNode;
  value: number | string;
  index: number | string;
  className?: string;
}

const CustomTabPanel: FC<CustomTabPanelProps> = ({
  children,
  value,
  index,
  className,
  ...other
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      className={className}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

export default CustomTabPanel;
